import { accountService } from '@/projects/admin/services/account-service';
import { t } from 'i18next';
import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import CustomStore from 'devextreme/data/custom_store';
import { DataGrid } from 'devextreme-react/data-grid';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';

const AccountList = () => {
    const [store, setStore] = useState<CustomStore>();
    const dataGridRef = useRef<DataGrid>(null);
    useEffect(() => {
        setStore(createCustomStore({
            key: ['id'],
            load: accountService.accountList,
            byKey: (key, loadOptions: any) => {
                if (key) {
                    loadOptions.filter = ["id", "=", key];
                }
            },
            remove: accountService.deleteAccount,
        }));
    }, [])

    const navigate = useNavigate();
    const goToEdit = (id: string) => {
        navigate(`/admin/account-definition/${id}`, { state: { id: id } })
    }

    return (
        <div>
            <DataGridWrapper
                permissonCode='Admin.Account.Account'
                datasource={store}
                pagerVisible={true}
                filterVisible={true}
                headerFilterVisible={true}
                enableCustomToolbarContent={true}
                navigateNewRecordPath='/admin/account-definition'
                props={{ id: 'account-list', ref: dataGridRef }}
                editingConfig={{
                    allowDeleting: true,
                    allowUpdating: true,
                    deleteMessageText: RemoveMessage('Account'),
                }}
                columns={[
                    { dataField: 'name', caption: t('account_name'), allowFiltering: true },
                    { dataField: 'accountNumber', caption: t('account_number'), allowFiltering: true },
                    { dataField: 'parentAccountName', caption: t('parent_account'), allowFiltering: true }
                ]}
                buttonConfig={[
                    {
                        name: 'edit',
                        icon: 'edit',
                        onClick: function (e: any) {
                            goToEdit(e.row?.data.id);
                        },
                    },
                    {
                        name: 'delete',
                        icon: 'trash',
                    },
                ]}
            />
        </div>
    )
}
export default AccountList